function LoginCtrl($auth, toaster, $state, $stateParams) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.loginForm = {};
  vm.errorType = $stateParams.errorType ? $stateParams.errorType : false;

  if(vm.errorType && vm.errorType == 'invalid_token') {
    toaster.pop('error', 'Invalid token.');
  }

  vm.submitLogin = function() {
    vm.submitted = true;
    $auth.submitLogin(vm.loginForm)
      .then(function() {
        if ($auth.user.organizations.length) {
          if ($auth.user.role == 'client') {
            $state.go('client.clientDashboard.tasks', {orgId: $auth.user.organizations[0].id}, {inherit: false});
          } else {
            $state.go('user.mainDashboard',{orgId: $auth.user.organizations[0].id}, {inherit: false});
          }
        }
        else {
          $state.go('user.connection.default', {inherit: false});
          toaster.pop('info', 'You do not have any organizations. Please connect to Xero and select organization.');
        }
      })
      .catch(function(resp) {
        console.log(resp);
      });
  };
}
export default {
  name: 'LoginCtrl',
  fn: LoginCtrl
};
